function PageLoader() {
	return <div>loading...</div>;
}

export default PageLoader;